import React from 'react';

const MainPage = () => {
    return (
        <h2>Web App is running... </h2>
    )
};

export default MainPage;